<template>
  <div class="py-4 container-fluid">
    <div class="row justify-content-center mt-5">
      <div class="col-md-6 text-center">
        <h1 class="display-1 font-weight-bolder text-secondary opacity-6">403</h1>
        <h4 class="mt-2">无访问权限</h4>
        <p class="text-muted mb-4">您的账号没有访问该页面的权限，请联系管理员。</p>
        <router-link to="/dashboards/dashboard-default" class="btn btn-primary btn-sm">
          返回首页
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "Forbidden" };
</script>
